import {NgModule} from '@angular/core';
import {
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule, MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    MatTreeModule
} from '@angular/material';
import {AgmCoreModule} from '@agm/core';
import {KeyValuePipe} from '@angular/common';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {AgGridModule} from 'ag-grid-angular';
import {NgImageSliderModule} from 'ng-image-slider';

import {FuseSharedModule} from '../@fuse/shared.module';

import {ApprovalPipe} from './config/approval-pipe';
import {BankAccountPipe} from './config/bank-account-pipe';
import {MonthPipe} from './config/month-pipe';
import {StringifyPipe} from './config/stringify-pipe';
import {TruncatePipe} from './config/truncate-pipe';
import {BooleanPipe} from './config/boolean-pipe';
import {RxApprovalPipe} from './config/rx-approval-pipe';
import {DayNamePipe} from './config/day-name-pipe';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {TimeConversionPipe} from './config/time-conversion-pipe';
import {DurationPipe} from './config/duration';
import {PercentagePipe} from './config/percentage-pipe';
import {RemoveUnderscorePipe} from './config/remove-underscore-pipe';
import {AmountConversionPipe} from './config/amount-conversion-pipe';
import {MatListModule} from '@angular/material/list';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {LeafletMarkerClusterModule} from '@asymmetrik/ngx-leaflet-markercluster';
import {MultiSelectionPipe} from './config/multi-selection.pipe';
import {NonDecimalPipe} from './config/non-decimal-pipe';
import {SelectedCheckPipe, SelectedSalesReturnCheckPipe} from './config/selected-check-pipe';
import {ActivePipe} from './config/active-pipe';
import {HasVisibleActionsPipe} from './config/has-visible-actions-pipe';
import {IsActionVisiblePipe} from './config/is-action-visible-pipe';


@NgModule({
    declarations: [TruncatePipe, StringifyPipe, ApprovalPipe, MonthPipe, MultiSelectionPipe, BankAccountPipe,
        BooleanPipe, RxApprovalPipe, DayNamePipe, TimeConversionPipe, DurationPipe, PercentagePipe, RemoveUnderscorePipe,
        AmountConversionPipe, NonDecimalPipe, SelectedCheckPipe, SelectedSalesReturnCheckPipe, ActivePipe, HasVisibleActionsPipe, IsActionVisiblePipe],
    imports: [
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatStepperModule,
        MatCheckboxModule,
        MatTreeModule,
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatExpansionModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatDividerModule,
        MatGridListModule,
        MatMenuModule,
        MatButtonToggleModule,
        MatRadioModule,
        MatChipsModule,
        MatTooltipModule,
        MatProgressBarModule,
        MatListModule,

        AgmCoreModule,
        NgxMatSelectSearchModule,
        FuseSharedModule,
        AgGridModule,
        NgImageSliderModule,
        NgxDaterangepickerMd,
        LeafletModule,
        LeafletMarkerClusterModule
    ],
    exports: [
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatStepperModule,
        MatCheckboxModule,
        MatTreeModule,
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatExpansionModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatDividerModule,
        MatGridListModule,
        MatMenuModule,
        MatButtonToggleModule,
        MatRadioModule,
        MatChipsModule,
        MatTooltipModule,
        MatProgressBarModule,
        MatListModule,
        LeafletModule,
        LeafletMarkerClusterModule,

        AgmCoreModule,
        NgxMatSelectSearchModule,
        FuseSharedModule,
        AgGridModule,
        NgImageSliderModule,
        NgxDaterangepickerMd,

        KeyValuePipe,
        TruncatePipe,
        StringifyPipe,
        ApprovalPipe,
        MonthPipe,
        MultiSelectionPipe,
        BankAccountPipe,
        BooleanPipe,
        RxApprovalPipe,
        DayNamePipe,
        TimeConversionPipe,
        DurationPipe,
        PercentagePipe,
        RemoveUnderscorePipe,
        AmountConversionPipe,
        NonDecimalPipe,
        SelectedCheckPipe,
        SelectedSalesReturnCheckPipe,
        ActivePipe,
        HasVisibleActionsPipe,
        IsActionVisiblePipe
    ],
    bootstrap: []
})
export class BizSharedModule {
}
